import { TermsAndConditions } from 'components/TermsAndConditions';

const ScreenWeb2PublishTermsAndConditions = () => <TermsAndConditions />;

export default ScreenWeb2PublishTermsAndConditions;
